import hmacSHA512 from "crypto-js/hmac-sha512";
import Base64 from "crypto-js/enc-base64";

var CryptoJS = require("crypto-js");

const dynamicValue = "04/03/2024";

export function AESEncrypt(pureText) {
  const privateKey = `${dynamicValue}_@INSPIRE`;
  var ciphertext = encodeURIComponent(
    CryptoJS.AES.encrypt(JSON.stringify(pureText), privateKey).toString()
  );
  return ciphertext;
}

export function AESDecrypt(encryptedText) {
  try {
    const privateKey = `${dynamicValue}_@INSPIRE`;
    var bytes = CryptoJS.AES.decrypt(
      decodeURIComponent(encryptedText),
      privateKey
    );
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    window.location.href = "/app/dashboard";
  }

  return decryptedData;
}

export function Sha256Hash(id, first, last) {
  const pureText = `${first}-${id}-${last}`;
  const privateKey = `${dynamicValue}_@INSPIRE`;
  var hash = encodeURIComponent(
    Base64.stringify(hmacSHA512(pureText, privateKey))
  );
  return hash;
}
